import TicketsViewPage from '~/components/Workflow/TicketsViewPage/TicketsViewPage';

export default function Page(props: any) {
  return <TicketsViewPage {...props} />;
}
